var isType = require('./isType');

module.exports = function isMaybe(x) {
  return isType(x) && ( x.meta.kind === 'maybe' );
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isMaybe.js
// module id = 1057
// module chunks = 0